export default __webpack_public_path__ + "static/media/internal mic - inactive.d43d2f36.d43d2f36.svg";